var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96834 17.7891C6.27397 18.0703 6.76949 18.0703 7.07512 17.7891C7.38075 17.5079 7.38075 17.0521 7.07512 16.7709L2.67196 12.72L23.2174 12.72C23.6496 12.72 24 12.3976 24 12C24 11.6023 23.6496 11.28 23.2174 11.28L2.67202 11.28L7.07512 7.22912C7.38075 6.94794 7.38075 6.49206 7.07512 6.21088C6.76949 5.92971 6.27397 5.92971 5.96834 6.21088L0.229222 11.4909C-0.0764063 11.7721 -0.0764063 12.2279 0.229222 12.5091L5.96834 17.7891Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.4099deaeacfba256159f85e8d20e68a7.svg";